import PasswordResetExpired from '../../components/passwords/PasswordResetExpired';
import './LoginPortal.scss';

const PasswordResetExpiredPortal = (props) => (
  <PasswordResetExpired {...props} />
);

export default PasswordResetExpiredPortal;
